import PropTypes from 'prop-types';
import FileCard from './FileCard/FileCard';
import GeneralCard from './GeneralCard/GeneralCard';

const ContentCard = ({ content, onSelect, color, height, onBackToTop }) => {
  switch (content.viewType) {
    case 'FILE':
      return (
        <FileCard
          onBackToTop={onBackToTop}
          height={height}
          content={content}
          color={color}
        />
      );

    default:
    case 'GENERAL':
      return (
        <GeneralCard
          onBackToTop={onBackToTop}
          content={content}
          onSelect={onSelect}
          color={color}
        />
      );
  }
};

ContentCard.propTypes = {
  content: PropTypes.shape({
    viewType: PropTypes.oneOf(['FILE', 'GENERAL']),
    thumbnail: PropTypes.arrayOf(
      PropTypes.shape({
        url: PropTypes.string,
      })
    ),
    media: { url: PropTypes.string, mime: PropTypes.string },
    description: PropTypes.string,
    enable: PropTypes.bool,
    id: PropTypes.number,
    size: PropTypes.string,
    title: PropTypes.string,
    downloadable: PropTypes.bool,
  }).isRequired,
  onSelect: PropTypes.func,
  color: PropTypes.string.isRequired,
  onBackToTop: PropTypes.func,
  height: PropTypes.number.isRequired,
};

ContentCard.defaultProps = {
  onSelect: () => {},
  onBackToTop: () => {},
};

export default ContentCard;
